import styled from "styled-components";
import { theme } from "../../theme";
import { CheckmarkIconLarge, CheckmarkIconSmall } from "./icons/CheckmarkIcons";
import { CrossIcon, CrossIconLarge } from "./icons/CrossIcon";
import { WarningIconM, WarningIcon } from "./icons/WarningIcon";

const Circle = styled.div<{
  color: string;
  size: "small" | "medium" | "large";
}>`
  background-color: ${(props) => props.color};
  width: ${(props) =>
    props.size === "small"
      ? "18px"
      : props.size === "medium"
        ? "36px"
        : "64px"};
  height: ${(props) =>
    props.size === "small"
      ? "18px"
      : props.size === "medium"
        ? "36px"
        : "64px"};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface Props {
  size?: "small" | "medium" | "large";
}

export const CheckedStatusCircle: React.FC<Props> = ({ size = "large" }) => {
  return (
    <Circle color={theme.colors.success20} size={size}>
      {size === "small" ? (
        <CheckmarkIconSmall color={theme.colors.success} />
      ) : (
        <CheckmarkIconLarge color={theme.colors.success} />
      )}
    </Circle>
  );
};

export const FailedStatusCircle: React.FC<Props> = ({ size = "large" }) => {
  return (
    <Circle color={theme.colors.error20} size={size}>
      {size === "small" ? (
        <CrossIcon color={theme.colors.error} />
      ) : (
        <CrossIconLarge color={theme.colors.error} />
      )}
    </Circle>
  );
};

export const WarningStatusCircle: React.FC<Props> = ({ size = "large" }) => {
  return (
    <Circle color={theme.colors.warning20} size={size}>
      {size === "small" ? (
        <WarningIcon color={theme.colors.warning} />
      ) : (
        <WarningIconM color={theme.colors.warning} />
      )}
    </Circle>
  );
};
